import { ChangeDetectorRef, Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { orderType, Signup } from '@app/_models';
import { Country, County, State } from '@app/_models/signups/geography';
import { AlertService, GeographyService, SignupService } from '@app/_services';
import { TooltipMessageService } from '@app/_services/toolservice.service';
import { breakpointPixels, FadvIconLibraryService, FadvModalComponent } from '@fa-switch-sharedservices/ng-elements';
import { Subscription } from 'rxjs';
import { PartnerComponent } from '../partner.component';

@Component({
  selector: 'app-partner-candidate',
  templateUrl: './partner-candidate.component.html',
  styleUrls: ['./partner-candidate.component.css']
})
export class PartnerCandidateComponent implements OnInit {

  form: UntypedFormGroup;
  loading = false;
  submitted = false;
  orderType = orderType;
  requireMiddleName = false;
  states: State[];
  countries: Country[];
  counties: County[];
  selectedState: string;
  selectedCounty: string;
  signup: Signup;
  orderHeaderVerbiage: string;
  orderSubHeaderVerbiage: string;
  middleNameToggle: Subscription;
  formModalOpen = false;
  inviteOrder = true;
  requireDL = false;
  displayInvite = false;
  innerWidth: number = window.innerWidth;
  colAlignment: string;
  fontSize: string;
  mobile: boolean;
  copyTextSize: string;
  welcomeSize: string;
  loginSize: string;
  noAccountSize: string;
  forgotSize: string;
  buttonSize: string;
  inputSize: string;
  currentOrderType: string;
  backButtonAlignment: string;
  nextButtonAlignment: string;

  @ViewChild('consentmodal') consentmodal!: FadvModalComponent;

  addressTooltip: string;
  legalNameTooltip: string;

  constructor(
    private router: Router,
    private signupService: SignupService,
    private partnerComponent: PartnerComponent,
    private appComponent: AppComponent
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.handleViewChange();
  }

  handleViewChange(): void {
    if (this.innerWidth <= breakpointPixels.sm) {
      this.backButtonAlignment = "center";
      this.nextButtonAlignment = "center";
    }
    else {
      this.backButtonAlignment = "right";
      this.nextButtonAlignment = "left";
    }
  }

  ngOnInit(): void {
    this.handleGetSignup();
    this.loading = false;
  }

  ngAfterViewInit(): void {
    this.partnerComponent.setStep(this.router.url);
    this.handleViewChange();
  }

  handleGetSignup(){
    this.signup = this.signupService.getSignup();
    if(this.appComponent.partner == false)
    {
      this.handleRefresh();
    }
  }

  onCancel() {
    this.router.navigate(['/partner/package'])
  }

  handleRefresh(){
    this.appComponent.partner = true;
    var logo = this.signup.partner.logoImageContentType + this.signup.partner.logo;
    this.appComponent.partnerLogo = logo; 
  }

  selectOrderType(order: string): void {

    if (order == 'invite') {
      this.signupService.saveCandidateDetails(this.signup);
      this.currentOrderType = order;
    }

    if (order == 'online') {
      this.signupService.saveCandidateDetails(this.signup);
      this.currentOrderType = order;
    }
  }

  handleNext(): void {
    if (this.currentOrderType == 'invite') {
      this.signupService.saveCandidateDetails(this.signup);
      this.router.navigate(['/partner/invite']);
    }

    if (this.currentOrderType == 'online') {
      this.signupService.saveCandidateDetails(this.signup);
      this.router.navigate(['/partner/online']);
    }
  }

}
